/**
 * Shared - Disabled State
 *
 * Component for displaying when a page/feature is disabled
 */

import { Icon, Card, CardBody } from '@repo/ui';
import type { IconName } from '@repo/ui';

export interface DisabledStateProps {
  /** Icon name to display */
  icon: IconName;
  /** Title of the disabled state */
  title: string;
  /** Description text */
  description: string;
  /** Additional help text */
  helpText?: string;
}

export function DisabledState({
  icon,
  title,
  description,
  helpText,
}: DisabledStateProps) {
  return (
    <Card variant="outlined" padding="lg">
      <CardBody className="text-center py-12">
        <Icon name={icon} className="h-16 w-16 text-xtnd-dark-300 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-xtnd-dark dark:text-xtnd-white mb-2">
          {title}
        </h2>
        <p className="text-xtnd-dark-500 dark:text-xtnd-dark-300 mb-6 max-w-md mx-auto">
          {description}
        </p>
        {helpText && (
          <p className="text-sm text-xtnd-dark-400 dark:text-xtnd-dark-400 mb-6">{helpText}</p>
        )}
      </CardBody>
    </Card>
  );
}

